<template>
  <px-custom-dialog v-model="dialog"
                    content-class="rounded-card"
                    width="1280">
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      Aprovação de solicitação
    </template>
    <template>
      <px-aprovacao-solicitacao-detalhes is-modal-view
                                         :aprovacao-id-prop="aprovacaoId"/>
    </template>
  </px-custom-dialog>
</template>

<script>
import AprovacaoSolicitacaoDetalhes
  from '@/modules/aprovacao-solicitacao/detalhes/AprovacaoSolicitacaoDetalhes.vue';

export default {
  props: {
    aprovacaoId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  components: {
    pxAprovacaoSolicitacaoDetalhes: AprovacaoSolicitacaoDetalhes,
  },
};
</script>
